import React, { useEffect, useState } from 'react';
import moment from 'moment';
import PayPopup from '../shopCart/PayPopup';
import { globalFileServer, globalFileIcon } from '../../../../axiosInstance';
import { GetProductsToOrder } from '../../../server/ProductToOrder';
import { CollectSiteProductSetOrder } from '../../../server/CollectSite';
import { orderPerCustomer } from '../../../server/Order';
import { useSelector, useDispatch } from 'react-redux';
import ProductInfo from '../../productInfo/ProductInfo';
import PopUp from '../../containers/PopUp';


const UserHistory = ({ name, setProductPopUp, setSelectedProd }) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);
  const [items, setItems] = useState([]);
  const toShow = 7;
  const [currentPage, setCurrentPage] = useState(1);
  const [orderIdPay, setOrderPay] = useState(null);
  const [HaveToPay, setHaveToPay] = useState(null);

	useEffect(() => {
		getItems();
		setTimeout(() => { window.scrollTo(0, 0) }, 200);
	}, [])


	const PayNow = (orderId, sum) => {
		setOrderPay(orderId);
		setHaveToPay(sum);
	}

	const closePayPopup = () => {
		setOrderPay(null)
	}

	const CloseProduct = (orderId) => {
		const orders = [...items]
		const selectOrderIndex = orders.findIndex(x => x.OrderId === orderId);
		const selectOrder = orders[selectOrderIndex]
		selectOrder.ProductsShow = false;
		setItems(orders)
	}
	const getProductToOrder = (orderId) => {

		const orders = [...items]
		const selectOrderIndex = orders.findIndex(x => x.OrderId === orderId);
		const selectOrder = orders[selectOrderIndex]
		selectOrder.ProductsShow = true;
		if (!selectOrder.Products) {
			GetProductsToOrder(orderId)
				.then(x => {
					selectOrder.Products = x.data;
					orders[selectOrderIndex] = selectOrder;
					setItems(orders);
				})
				.catch(() => console.log("error"));
		}
		else {
			setItems(orders)
		}
	}

	const setPage = (currentPage) => {
		setCurrentPage(currentPage);
		window.scrollTo(0, 0);
	}
	const getItems = () => {
		orderPerCustomer(user.Id)
			.then(x => setItems(x.data))
			.catch(() => console.log("error"))
	}

  const getStatusClass = (status) => {
    switch(status) {
      case 'הזמנה סגורה': return 'status-ready';
      case 'בליקוט רובוט': return 'status-demand';
      case 'ממתין לליקוט': return 'status-done';
      default: return 'status-default';
    }
  };
  
	let pagination = [...Array(Math.ceil(items.length / toShow)).keys()];
  
  return (
    <div className="user-history" dir="rtl">
      {orderIdPay ? <PayPopup
				closePayPopup={closePayPopup}
				orderId={orderIdPay}
				SumPay={HaveToPay}
				tranmode={false}
			/> : null}
      <p className='user-history-header'> <img  loading="lazy" src={globalFileIcon + 'history_order.svg'} alt="history_order" />
      ההזמנות של {name}</p>        
      <div className="orders-grid">
        {!items.length ? <h1 className="no-products">אין הזמנות</h1> : null}
        {items.map((element, index) => index < toShow * currentPage && index >= (currentPage - 1) * toShow ? (
          <div key={index} className="order-card">
            <div className="order-header">
              <div>מס' הזמנה: {element.OrderWebId}</div>
              <div>סך הזמנה: ₪{element.PaymentOrg}</div>
            </div>
            <div className="order-info">
              <div className="order-info-header">
                <span className={`status-badge ${getStatusClass(element.StatusName)}`}>
                  {element.StatusName}
                </span>
              </div>
              <div className="info-row">
                <span className="info-icon">👤</span>
                <span>{element.CustomerName}</span>
              </div>
              <div className="info-row">
                <span className="info-icon">📍</span>
                <span className="location-text">{element.FullAddress}</span>
              </div>
              <div className="info-row">
                <span className="info-icon">🕒</span>
                <span>{moment(element.ExpectedDate).format("DD.MM.YY HH:mm")}</span>
              </div>
              {element.Comment && (
                <div className="info-row">
                  <span className="info-icon">✏️</span>
                  <span className="comment-text">{element.Comment}</span>
                </div>
              )}
              <div className="info-row">
                <span className="info-icon">💳</span>
                <span>כרטיס: {element.Digit4}************</span>
              </div>
              {element.PaymentDateTime && (
                <div className="info-row">
                  <span className="info-icon">📅</span>
                  <span>תאריך תשלום: {moment(element.PaymentDateTime).format("DD.MM.YY")}</span>
                </div>
              )}
            </div>
            <div className="order-actions">
            {element.HaveToPay && element.CanPay ?
									<div className="wrap">
										<button className='btn' onClick={() => PayNow(element.OrderId, element.HaveToPay)}>לתשלום &gt;</button>
										<p>{element.HaveToPay}</p>
									</div> 
            : null}
                {element.StationId === user.StationId && (
                  <button className='btn' onClick={() => dispatch(CollectSiteProductSetOrder(element.OrderId))}>
                    העתק לסל
                  </button>
                )}            
                <button className='action-button view-order' onClick={() => getProductToOrder(element.OrderId)}>
                הצגת הזמנה
            </button>
            </div>
            {element.ProductsShow && element && <PopUp width='700px' close={() => CloseProduct(element.OrderId)} className="order-popup">
                <div className="modal-body">
                  <h3 className="header">פריטים בהזמנה מס׳ {element.OrderWebId}:</h3>
                  <div className="order-table-container">
                  <table className="order-table">
                    <thead>
                      <tr>
                        <th>מוצר</th>
                        <th>כמות</th>
                        <th>מחיר יח'</th>
                        <th>סה"כ</th>
                      </tr>
                    </thead>
                    <tbody>
                    {element.Products && element.Products.map((el, idx) => {
                        if (idx === 0 && el.Id === 3384) // delivery product
                          return null;
                        return (
                          <tr key={el.Id}>
                            <td className="product-details"onClick={()=>{setSelectedProd(el); setProductPopUp(true)}} >
                                  <p className="description">{el.Description}</p>
                                  <ProductInfo selectedProd={el} />
                            </td>
                            <td className="quantity">{el.Quantity}</td>
                            <td className="price">₪{el.Price}</td>
                            <td className="total">₪{el.Quantity * el.Price}</td>
                          </tr>
                        );
                      })}
                       <tr className="delivery">
                        <td>משלוח</td>
                        <td/>
                        <td/>
                        <td>₪{element.Products[0].Id === 3384 ? element.Products[0].Price : 0.00}</td>
                      </tr>
                    </tbody>
                    <tfoot> 
                      <tr>
                        <td colSpan="2">סה"כ: {element.Products[0].Id === 3384 ? element.NumOfProducts-1 : element.NumOfProducts} פריטים</td>
                        <td/>
                        <td colSpan="2" className="final-total">₪{element.PaymentOrg}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                  
                  <div className="modal-actions">
                    {/* {element.StationId === user.StationId ? */}
                        <button className="button-primary" onClick={() => dispatch(CollectSiteProductSetOrder(element.OrderId))}>
                          העתק לסל
                        </button>
                       {/* : <span className="different-station-text">הזמנה זו בוצעה מתחנה שונה</span>} */}
                        <button 
                          onClick={() => CloseProduct(element.OrderId)} 
                          className="button-secondary">
                          סגור
                    </button>
                  )}
                  </div>
                </div>
          </PopUp>} 

          </div>
        ) : null)}
      </div>
      
      {pagination.length > 1 ? (
        <div className="pagination">
          <ul>
            {currentPage > 1 ? (
              <li onClick={() => setPage(currentPage - 1)}>
                <img loading="lazy" src={globalFileIcon + 'right-arrow.svg'} alt="back" />
              </li>
            ) : null}
            
            {pagination.map((element, index) => {
              let pageN = element + 1;
              return (
                <li onClick={() => setPage(pageN)} key={index} className={pageN === currentPage ? 'active' : null}>
                  <span>{pageN}</span>
                </li>
              );
            })}
            
            {currentPage < pagination.length ? (
              <li onClick={() => setPage(currentPage + 1)}>
                <img loading="lazy" src={globalFileIcon + 'left-arrow.svg'} alt="next" />
              </li>
            ) : null}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default UserHistory;